import { createSlice } from "@reduxjs/toolkit";
import { fetchNursesReducer } from "../../reducer/nurseManagement/fetchNursesReducer";

import i18n from "../../i18n";
const initialState = {
  data: [],
  pagination: { page: 1, limit: 10, total: 0, totalPages: 1 },
  isLoading: false,
  error: null,
};

const nurseManagementSlice = createSlice({
  name: "nurseManagement",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNursesReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchNursesReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.nurses || [];
        state.pagination = {
          page: action.payload?.pagination?.page || 1,
          limit: action.payload?.pagination?.limit || 10,
          total: action.payload?.pagination?.total || 0,
          totalPages:
            action.payload?.pagination?.totalPages ||
            action.payload?.pagination?.total_pages ||
            1,
        };
      })
      .addCase(fetchNursesReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t("toast.failedToLoadNurses");
      });
  },
});

export default nurseManagementSlice.reducer;
